import { render } from "./Others6Charts.vue?vue&type=template&id=35fd9107&scoped=true"
import script from "./Others6Charts.vue?vue&type=script&lang=js"
export * from "./Others6Charts.vue?vue&type=script&lang=js"

import "./Others6Charts.vue?vue&type=style&index=0&id=35fd9107&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fd9107"]])

export default __exports__